import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kt_header",
  style: {},
  class: "header align-items-stretch"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center d-lg-none ms-n3 me-1\" title=\"Show aside menu\"><div class=\"btn btn-icon btn-active-light-primary\" id=\"kt_aside_mobile_toggle\"><span class=\"svg-icon svg-icon-2x mt-1 opacity-30\"><img src=\"media/icons/duotune/abstract/abs015.svg\"></span></div></div><div class=\"d-flex align-items-center flex-grow-1 flex-lg-grow-0\"><a href=\"#\" class=\"d-lg-none\"> HKO Tool </a></div>", 2)
const _hoisted_4 = { class: "d-flex align-items-stretch justify-content-between flex-lg-grow-1" }
const _hoisted_5 = {
  class: "d-flex align-items-stretch",
  id: "kt_header_menu_nav"
}
const _hoisted_6 = { class: "d-flex align-items-stretch flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTMenu = _resolveComponent("KTMenu")!
  const _component_KTTopbar = _resolveComponent("KTTopbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }, "d-flex align-items-stretch justify-content-between"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_KTMenu)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_KTTopbar)
        ])
      ])
    ], 2)
  ]))
}